import Styles from '../../styles/pages/experiencias/OffersCards.module.scss';
import { apiRestGet } from '../../services/request';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { formatterMoney, splitField } from '../../shared/utils';

type Props = {
  idTipoTurismo: number;
};

interface oferta {
  nombreOferta: string;
  descripcion: string;
  imagen: string;
  nombrePST: string;
  idOferta: number;
  calificacion: number;
  valor: number;
  valorCalculado: number;
  descuento: number | null;
}

const OffersCards = ({ idTipoTurismo }: Props) => {
  const router = useRouter();
  const [locale, setLocale] = useState(router?.locale);

  const [offers, setOffers] = useState<oferta[] | []>([]);
  const [pagina, setPagina] = useState<number>(0);
  const [maxim, setMaxim] = useState<number>(0);

  const paginaSet = (tipo: number) => {
    switch (tipo) {
      case 2:
        if (pagina < maxim - 1) setPagina(pagina + 1);
        break;
      default:
        if (pagina > 0) setPagina(pagina - 1);
        break;
    }
  };

  const getOfertas = async () => {
    const body = {
      'id_tipo_turismo[][]': idTipoTurismo,
      pagina: pagina,
      cant_filas: 4,
    };
    const ofertas: oferta[] = [];
    const resultados = await apiRestGet(
      process.env.NEXT_PUBLIC_OFFER_EVENT_READ_SERVICE_URL + 'offer/all',
      body
    );
    if (resultados.status == 200) {
      if (!Array.isArray(resultados.data)) {
        if (resultados.data.ofertas.length > 0) {
          resultados.data.ofertas.forEach((oferta) => {
            ofertas.push({
              calificacion: oferta.calificacion,
              descripcion: oferta.descripcion,
              descuento: oferta.descuento,
              idOferta: oferta.id_oferta,
              imagen: oferta.imagenes[0]?.ImagenURL,
              nombreOferta: oferta.nombre,
              nombrePST: oferta.PST.razon_social,
              valor: oferta.valor,
              valorCalculado: oferta.valor_calculado,
            });
          });
          setMaxim(Math.ceil(resultados.data.total_result / 5));
        }
      }
    }

    setOffers(ofertas);
  };

  useEffect(() => {
    if (router.locale) {
      setLocale(router?.locale);
    }
  }, [router?.locale]);

  useEffect(() => {
    getOfertas();
  }, []);

  useEffect(() => {
    getOfertas();
  }, [pagina]);

  const redirection = (id: number) => {
    router.replace('/servicio/' + id).then();
  };

  return (
    <div className={Styles.content_offers_tourist}>
      {offers?.length === 0 ? (
        <h4>No hay ofertas disponibles para mostrar</h4>
      ) : (
        <>
          <h2 style={{ display: 'flex', justifyContent: 'center' }}>
            Ofertas turísticas
          </h2>
          <div className={Styles.content_cards_offers}>
            {offers.map((item, index) => {
              console.log(`Oferta #${index + 1}:`, item);

              return (
                <div
                  className={Styles.content_cards_offers_item}
                  key={index}
                  style={{ overflow: 'hidden' }}
                  onClick={() => redirection(item.idOferta)}
                >
                  <img
                    alt="image"
                    src={process.env.NEXT_PUBLIC_STORAGE_URL + item.imagen}
                  />
                  <div>
                    <p className={Styles.department_text}>
                      Departamento, Municipio
                    </p>
                    <p className={Styles.title_text}>
                      {splitField(item.nombreOferta, locale)}
                    </p>
                    <p className={Styles.subtitle_text}>
                      Por: <b>{item.nombrePST}</b>
                    </p>
                    <div className={Styles.group_star}>
                      <img alt="image" src="/images/municipios/star.svg" />
                      <p>{item.calificacion}</p>
                    </div>
                    <p className={Styles.card_paragraph}>
                      {splitField(item.descripcion, locale)}
                    </p>
                    <div className={Styles.group_price}>
                      <p className={Styles.desde}>Desde</p>
                      {/* <p className={Styles.price_sub}>
                    {formatterMoney.format(item.valor)}
                  </p> */}
                      <p className={Styles.price_green}>
                        {formatterMoney.format(item.valorCalculado)}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default OffersCards;
